module.exports = __webpack_public_path__ + "img/icon-minus.ea4b18c1.svg";